import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGrowth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"growth, grow, leafs"} maskId="square-filled-radius-0-stroke-1-IconGrowth"><path d="M3 3V5C3 9.14214 6.35786 12.5 10.5 12.5H11.5V21H12.5V15.5H13.5C17.6421 15.5 21 12.1421 21 8V6H19C16.199 6 13.7567 7.53544 12.4687 9.81053C12.1207 5.99157 8.90969 3 5 3H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGrowth;
